import roles from "@/roles";
export default [
  {
    icon: "ac_unit",
    title: "Calamities",
    roles: [roles.ADMIN, roles.CALAMITY_ADMIN],
    children: [
      {
        router: true,
        title: "Calamities",
        to: "Calamities",
        roles: [roles.ADMIN, roles.CALAMITY_ADMIN]
      },
      {
        router: true,
        title: "Potential Calamities",
        to: "PotentialCalamities",
        roles: [roles.ADMIN, roles.CALAMITY_ADMIN]
      },
      {
        router: true,
        title: "Potential Calamities (New)",
        to: "PotentialCalamitiesReport",
        roles: [roles.ADMIN, roles.CALAMITY_ADMIN]
      },
      {
        router: true,
        icon: "map",
        title: "Map",
        to: "CalamityMap",
        roles: [roles.ADMIN, roles.CALAMITY_ADMIN]
      }
    ]
  }
];
